import { initializeApp } from '@firebase/app';
import { getAuth, initializeAuth, browserLocalPersistence } from '@firebase/auth';
import { getFirestore } from '@firebase/firestore';
import { getFunctions } from '@firebase/functions';
import { getStorage } from '@firebase/storage';
import firebaseConfig from './firebaseConfig';

// Initialize Firebase app with explicit region
const app = initializeApp(firebaseConfig);

// Initialize Auth with local persistence (persists across page refreshes)
const auth = initializeAuth(app, {
  persistence: [browserLocalPersistence]
});

// Initialize other services with region
const db = getFirestore(app);
const functions = getFunctions(app, process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || 'us-central1');
const storage = getStorage(app);

// If you're using local emulator, uncomment this:
// connectFunctionsEmulator(functions, "localhost", 5001);

// Export initialized services
export { app, auth, db, storage, functions };

// Export getters for backward compatibility
export const getFirebaseApp = () => app;
export const getFirebaseAuth = () => auth;
export const getFirebaseDb = () => db;
export const getFirebaseStorage = () => storage;
export const getFirebaseFunctions = () => functions;
